export default {
  layout: "Layouts",
  invoiceDefaultSettings: "General",
  invoiceNumberSettings: "Invoice number",
  invoicePrintTemplateSettings: "Invoice print template",
}
